import { Input } from "components/ui/input";
import React from "react";
import { parseGoalTarget } from "./goal-grid";

interface SharedTargetInputProps {
    columnLabel: string;
    shared: number | null;
    onChange: (target: number) => void;
}

const hiddenSpinnerClasses =
    "[&_input::-webkit-inner-spin-button]:appearance-none [&_input::-webkit-outer-spin-button]:appearance-none [&_input]:[-moz-appearance:textfield]";

const isStepKey = (key: string): boolean => key === "ArrowUp" || key === "ArrowDown";

export const SharedTargetInput: React.FC<SharedTargetInputProps> = ({
    columnLabel,
    shared,
    onChange,
}) => {
    const mixed = shared === null;
    return (
        <Input
            type="number"
            min="0"
            textSize="sm"
            className={mixed ? hiddenSpinnerClasses : ""}
            placeholder={mixed ? "Mixed" : ""}
            aria-label={`${columnLabel} goal for everyone`}
            value={shared ? String(shared) : ""}
            onChange={event => onChange(parseGoalTarget(event.target.value))}
            onKeyDown={event => {
                if (mixed && isStepKey(event.key)) {
                    event.preventDefault();
                }
            }}
            onWheel={event => {
                if (mixed) {
                    event.currentTarget.blur();
                }
            }}
        />
    );
};
